module.exports = __webpack_public_path__ + "img/file_format_ofx.05b55586.png";